export default __webpack_public_path__ + "static/media/a023-3.b7568d6b.png";